import { Box } from "@mui/material";
import DebouncedTextField from "@/components/DebouncedTextField";
import CustomSelect from "@/components/CustomSelect";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  MINI_COG_TEXT,
  MINI_COG_VERSION_LABEL,
  MINI_COG_WORD_VERSIONS,
} from "../initial-f2f-mini-cog-constant";

export interface MiniCogRecallFieldsProps {
  wordListVersion: string;
  personsAnswers: string;
  onVersionChange: (version: string) => void;
  onAnswersChange: (answers: string) => void;
}

const VERSION_OPTIONS = MINI_COG_WORD_VERSIONS.map((_, index) => ({
  value: String(index + 1),
  label: `${MINI_COG_VERSION_LABEL} ${index + 1}`,
}));

const MiniCogRecallFields = ({
  wordListVersion,
  personsAnswers,
  onVersionChange,
  onAnswersChange,
}: MiniCogRecallFieldsProps) => (
  <Flex gap={2} alignItems="flex-end" flexWrap="wrap">
    <Box minWidth={180}>
      <Text size={12} c="text.secondary" mb={0.5}>
        {MINI_COG_TEXT.wordListVersionLabel}
      </Text>
      <CustomSelect
        options={VERSION_OPTIONS}
        placeholder={MINI_COG_TEXT.wordListVersionPlaceholder}
        value={wordListVersion || null}
        onChange={(value) => onVersionChange(value ?? "")}
      />
    </Box>
    <Box flex={1} minWidth={240}>
      <Text size={12} c="text.secondary" mb={0.5}>
        {MINI_COG_TEXT.personsAnswersLabel}
      </Text>
      <DebouncedTextField
        size="small"
        fullWidth
        value={personsAnswers}
        onChange={onAnswersChange}
      />
    </Box>
  </Flex>
);

export default MiniCogRecallFields;
